import { render, staticRenderFns } from "./TextProcessor.vue?vue&type=template&id=f79a4f1e&scoped=true"
import script from "./TextProcessor.vue?vue&type=script&lang=js"
export * from "./TextProcessor.vue?vue&type=script&lang=js"
import style0 from "./TextProcessor.vue?vue&type=style&index=0&id=f79a4f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79a4f1e",
  null
  
)

export default component.exports